import React from 'react';
import { Box, Popover } from '@televet/kibble-ui';

const InfoPopover = ({
  Trigger,
  isPopoverDisabled,
  popoverText,
}: {
  Trigger: React.ReactFragment;
  isPopoverDisabled: boolean;
  popoverText: string;
}): JSX.Element => {
  if (!isPopoverDisabled) {
    return <>{Trigger}</>;
  }
  return (
    <Popover anchor={<Box width="fit-content">{Trigger}</Box>} trigger="hover" placement="right">
      {popoverText}
    </Popover>
  );
};

export default InfoPopover;
